import React, { useEffect } from 'react';
import { Grid, makeStyles } from '@rbx/ui';
import { usePathname } from 'next/navigation';
import PrimaryRail from '../primaryRail/PrimaryRail';
import EventProvider from '../providers/EventProvider';
import Header from './components/Header';
import PageContent from './components/PageContent';
import { CONTENT_GRID_AREA, HEADER_GRID_AREA, PRIMARY_RAIL_GRID_AREA } from './constants';
import WorkspaceProvider from '../providers/WorkspaceProvider';
import { useRailContext } from './providers/RailProvider';

const useStyles = makeStyles()(() => ({
  container: {
    display: 'grid',
    height: '100vh',
    width: '100vw',
    gridTemplateAreas: `
      "${PRIMARY_RAIL_GRID_AREA} ${HEADER_GRID_AREA}"
      "${PRIMARY_RAIL_GRID_AREA} ${CONTENT_GRID_AREA}"
    `,
    gridTemplateRows: 'auto 1fr',
    gridTemplateColumns: 'auto 1fr',
  },
}));

type LayoutComponents = {
  Header: typeof Header;
  PageContent: typeof PageContent;
  Rail: typeof PrimaryRail;
};

export const CreatorHubLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const {
    classes: { container },
  } = useStyles();
  const pathname = usePathname();
  const { drawerVariant, setPrimaryRailOpen, setAllToolsOpen, setLearnOpen } = useRailContext();

  useEffect(() => {
    if (drawerVariant === 'temporary') {
      setPrimaryRailOpen(false);
    }
    setAllToolsOpen(false);
    setLearnOpen(false);
  }, [setPrimaryRailOpen, pathname, drawerVariant, setAllToolsOpen, setLearnOpen]);

  return <Grid classes={{ root: container }}>{children}</Grid>;
};

const CreatorHubLayoutContainer: React.FC<React.PropsWithChildren> & LayoutComponents = ({
  children,
}) => {
  return (
    <EventProvider>
      <WorkspaceProvider>
        <CreatorHubLayout>{children}</CreatorHubLayout>
      </WorkspaceProvider>
    </EventProvider>
  );
};

CreatorHubLayoutContainer.Header = Header;
CreatorHubLayoutContainer.PageContent = PageContent;
CreatorHubLayoutContainer.Rail = PrimaryRail;

export default CreatorHubLayoutContainer;
